import { Link } from "react-router-dom";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_deployment-hub-35/artifacts/5izm5um0_ChatGPT%20Image%20Apr%2027%2C%202026%20at%2012_49_38%20PM.png";

/**
 * Official BWZ Brandon Wheelz · OPS Central brand mark.
 * The artwork has a black background, so it sits well on any dark surface.
 * On light surfaces we wrap it in a dark rounded container.
 */
export function BrandLogo({ size = "md", surface = "dark", to = "/dashboard", className = "", testId = "brand-logo" }) {
  const dimensions = {
    xs: "h-8 w-8",
    sm: "h-10 w-10",
    md: "h-12 w-12",
    lg: "h-20 w-20",
    xl: "h-32 w-32",
  }[size] || "h-12 w-12";

  const mark = (
    <div
      data-testid={testId}
      className={`${dimensions} rounded-lg bg-black flex items-center justify-center overflow-hidden flex-shrink-0 ${className}`}
    >
      <img src={LOGO_URL} alt="BWZ Brandon Wheelz · OPS Central" className="w-full h-full object-contain" />
    </div>
  );

  if (!to) return mark;
  return (
    <Link to={to} className="inline-flex items-center gap-2.5" data-testid={`${testId}-link`}>
      {mark}
    </Link>
  );
}

export function BrandLogoFull({ size = "lg", className = "", testId = "brand-logo-full" }) {
  const dimensions = {
    md: "h-16 w-16",
    lg: "h-24 w-24",
    xl: "h-32 w-32",
    "2xl": "h-40 w-40",
  }[size] || "h-24 w-24";
  return (
    <div data-testid={testId} className={`${dimensions} rounded-xl bg-black flex items-center justify-center overflow-hidden ${className}`}>
      <img src={LOGO_URL} alt="BWZ Brandon Wheelz · OPS Central" className="w-full h-full object-contain" />
    </div>
  );
}

export const BWZ_LOGO_URL = LOGO_URL;
export default BrandLogo;
